import React from 'react';
import { TextField, TextDescription } from '@ann/web-components';
import { TextDescriptionWrapper } from './BasicInfoSection.styled';

const BasicInfoSection = ({
  name,
  description,
  onNameChange,
  onDescriptionChange,
}) => {
  return (
    <>
      <TextField
        label="Agent Name"
        placeholder="Enter agent name"
        value={name}
        onChange={onNameChange}
        size="small"
      />

      <TextDescriptionWrapper>
        <TextDescription
          height="172px"
          label="Description (optional)"
          value={description}
          onChange={onDescriptionChange}
          placeholder="Briefly describe this agent purpose or function"
          size="small"
        />
      </TextDescriptionWrapper>
    </>
  );
};

export default BasicInfoSection;

